export default () =>
  ({
    default: {
      wrap: {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
      },

      buttonsWrapper: {
        alignItems: 'center',
        display: 'flex',
      },
    },
  }) as const
